module.exports = __webpack_public_path__ + "static/media/air-conditioner.1de8ba05.png";